import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22theme.jsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../public/fonts/roboto/Roboto-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/roboto/Roboto-Medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/roboto/Roboto-Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22fallback%22:[%22Arial%22,%22sans-serif%22]}],%22variableName%22:%22fontRoboto%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'fontRoboto', 'fontRoboto Fallback', Arial, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
